var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("group-page-header", { attrs: { title: "Group Posts" } }, [
        _c(
          "span",
          { attrs: { slot: "additionalButtons" }, slot: "additionalButtons" },
          [
            _c("vue-search-input", {
              staticClass: "hidden-md hidden-lg",
              attrs: {
                "min-letters-count": 2,
                "max-width": 170,
                collapsable: "",
              },
              on: { search: _vm.startSearch, cancel: _vm.cancelSearch },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "stories-list",
        {
          ref: "storiesList",
          attrs: {
            "stories-list-endpoint": _vm.storiesListEndpoint,
            "allow-filter": false,
            "allow-create": false,
            "track-query-in-url": false,
            "search-field-classes": ["hidden-xs", "hidden-sm"],
            "use-query-as-back-href": "",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "row margin-15-top",
              attrs: { slot: "emptyMessage" },
              slot: "emptyMessage",
            },
            [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n                    There has been nothing added to this Group's Stories yet\n                "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row margin-15-top",
              attrs: { slot: "emptyMessageSearch" },
              slot: "emptyMessageSearch",
            },
            [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n                    No Stories were found that match your query\n                "
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }